import Modal from "react-bootstrap/Modal";
import React from "react";

const ModalCloseSettingsDelivery = ({title, setToggle, onHide, show}) => {
    const handlerReplaced = (method) => {
        switch (method) {
            case 'TRUE': {
                setToggle(false);
                return onHide()
            }
            case 'FALSE': {
                return onHide()
            }
            default: return
        }
    }
    return (
        <Modal show={show} size="lg" centered>
            <Modal.Body>
                <div className="modal__wrapper">
                    <div className="inner__modal">
                        <div className="replace__modal">
                            <div className="replace__icon">
                                <img src="/img/modalwarn.svg" alt="modalwarn" />
                            </div>
                            <h6>{title}</h6>
                            <div className="replace__buttons">
                                <button onClick={() => handlerReplaced('TRUE')} type='button' className="replace__confirm">Yes</button>
                                <button onClick={() => handlerReplaced('FALSE')} type='button' className="close__replace">No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalCloseSettingsDelivery